module.exports = require("chart.js/auto");